import React, { useEffect, useState } from "react";
import ProteinImage from "../assets/images/protein.png";

const FoodItemCardView = ({ foodListCardViewData, history }) => {
    const [foodList, setFoodList] = useState(foodListCardViewData);

    useEffect(() => {
        setFoodList(foodListCardViewData)
    }, [foodListCardViewData])

    const cardProteinBlock = (cardInfo) => {
        return (
            <>
                {/* <div className="card-body col"> */}
                {
                    cardInfo.protein_calorie_type !== null &&
                    cardInfo.protein_calorie_type !== undefined &&
                    cardInfo.protein_calorie_type.toString().toLowerCase() !== "none" &&
                    <div className="card-block">
                        <div className="card-field-value">
                            {cardInfo.protein_calorie_type === null ? " " : cardInfo.protein_calorie_type}
                        </div>
                        <div className={"card-field-label"}>
                            <img src={ProteinImage} className="foodList_protein_img" />
                            {"Protein Type"}
                        </div>
                    </div>
                }
                {/* </div> */}
                {
                    parseInt(cardInfo.protein_calories) !== 0 && cardInfo.protein_calories !== null &&
                    <div className="card-block col">
                        <div className="card-field-value">
                            {cardInfo.protein_calories}
                        </div>
                        <div className="card-field-label">
                            <i className={`icon icon-calories xl-icon`} />
                            {"Protein Calories"}
                        </div>
                    </div>
                }
            </>
        );
    };

    const cardBodyBlock = (cardInfo) => {
        return (
            <>
                {
                    parseInt(cardInfo.servings_vegetable) !== 0 &&
                    <div className="card-block col">
                        <div className="card-field-value">
                            {cardInfo.servings_vegetable}
                        </div>
                        <div className="card-field-label">
                            <i className={`icon icon-veggies xl-icon`} />
                            {"Vegetables"}
                        </div>
                    </div>
                }
                {
                    parseInt(cardInfo.servings_misc) !== 0 &&
                    <div className="card-block col">
                        <div className="card-field-value">
                            {cardInfo.servings_misc}
                        </div>
                        <div className="card-field-label">
                            <i className={`icon icon-misc xl-icon`} />
                            {"Misc"}
                        </div>
                    </div>
                }
            </>
        );
    };

    const handleCardClick = (item) => {
        history.push({
            pathname: `/nutrition/food-database/${item.id}/view`,
            state: { isViewOnly: true }
        });
    }


    const renderCard = (item) => (
        <div className={'card card-primary'}>
            <div className="card-header" onClick={() => handleCardClick(item)}>
                <div className="card-body">
                    <div className="card-block">
                        <div className={"card-field-label nameHeader"}>
                            {item.name}
                        </div>
                    </div>
                </div>
                <div className="card-body food-list-body row">
                    {cardProteinBlock(item)}
                </div>
                <div className="card-body food-list-body row">
                    {cardBodyBlock(item)}
                </div>
            </div>
        </div>
    )

    const renderTreeLevel = (list) => {
        return (
            <div className="row">
                {list && list.length ? (
                    <>
                        {list.map((item) => {
                            return (
                                <React.Fragment>
                                    <div className={'food-list-card-view col-4'}>
                                        {renderCard(item)}
                                    </div >
                                </React.Fragment>
                            );
                        })}
                    </>
                ) : (
                    <li className="tree-blank">No Items found!</li>
                )}
            </div>
        );
    };

    return renderTreeLevel(foodList);
};

export default FoodItemCardView;
